(() => {
  // HERLAYRA consent — bridges the shopper's choice into Shopify Customer Privacy API, which is what
  // actually gates the store's Web Pixels (Meta / TikTok / Google / Klaviyo). Google Consent Mode is
  // kept in sync for any gtag consumer. Region behaviour (EEA opt-in / US opt-out + GPC) is configured
  // in Admin → Settings → Customer privacy; this script reflects consent into both systems.
  //
  // MIGRATION FLAG: once Shopify's NATIVE cookie banner is enabled (Settings → Customer privacy),
  // flip USE_CUSTOM_BANNER = false so this script stops drawing its own banner (avoids a double banner)
  // and only mirrors consent for older stored choices / GPC. Footer links point to Shopify's opt-out page.
  // TEST ON A DRAFT THEME before publishing (verify pixels gate pre/post-consent, EEA vs US, GPC).
  const USE_CUSTOM_BANNER = false;

  window.dataLayer = window.dataLayer || [];
  function gtag(){ dataLayer.push(arguments); }
  const GTAG_DENY  = { ad_storage:'denied',  analytics_storage:'denied',  ad_user_data:'denied',  ad_personalization:'denied' };
  const GTAG_GRANT = { ad_storage:'granted', analytics_storage:'granted', ad_user_data:'granted', ad_personalization:'granted' };
  const key = 'herlayra_cookie_consent';
  const hasGpc = navigator.globalPrivacyControl === true;
  const storedChoice = localStorage.getItem(key);
  gtag('consent', 'default', (hasGpc || storedChoice === 'declined') ? GTAG_DENY : GTAG_GRANT);
  if (hasGpc && localStorage.getItem(key) !== 'declined') localStorage.setItem(key, 'declined');

  // Reflect consent into Shopify Customer Privacy API — THIS is what controls the Web Pixels.
  function setShopifyConsent(granted){
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.setTrackingConsent !== 'function') return;
      cp.setTrackingConsent({
        analytics:    granted,
        marketing:    granted,
        preferences:  granted,
        sale_of_data: granted   // decline / GPC => false => honours "Do Not Sell or Share"
      }, function(){});
    } catch(e){}
  }

  function apply(v){
    const granted = !hasGpc && v !== 'declined';
    gtag('consent', 'update', granted ? GTAG_GRANT : GTAG_DENY);
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err){
          if (!err) setShopifyConsent(granted);
        });
      } else {
        setShopifyConsent(granted);
      }
    } catch(e){ setShopifyConsent(granted); }
  }

  function choiceText(){
    return hasGpc
      ? 'Your browser privacy signal is on. You can review or update privacy choices through our privacy controls.'
      : 'You can review or update your privacy choices at any time.';
  }

  function showChoices(force){
    if (!USE_CUSTOM_BANNER && !force) return;                 // Shopify native banner is in charge
    if (document.querySelector('[data-hly-consent]')) return;
    if (!force && localStorage.getItem(key)) return;
    const bar = document.createElement('div');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Privacy choices');
    bar.setAttribute('data-hly-consent', '');
    bar.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:90;background:#FAFAF7;color:#0C3B48;border:1px solid #D8D2BE;border-radius:8px;padding:14px;box-shadow:0 10px 28px rgba(12,59,72,.16);font:14px Inter,system-ui,sans-serif';
    bar.innerHTML = '<b>Privacy choices</b><div style="margin:6px 0 10px">' + choiceText() + ' <a href="/policies/privacy-policy" style="color:#0C3B48;text-decoration:underline;text-underline-offset:3px">Privacy Policy</a>.</div><button data-accept style="background:#0C3B48;color:#F5F2E6;border:0;border-radius:8px;padding:10px 14px;margin-right:8px;min-height:44px;display:inline-flex;align-items:center">Accept</button><button data-decline style="background:#fff;color:#0C3B48;border:1px solid #0C3B48;border-radius:8px;padding:10px 14px;min-height:44px;display:inline-flex;align-items:center">Decline</button>';
    if (hasGpc) { const a = bar.querySelector('[data-accept]'); if (a) a.setAttribute('hidden', ''); }
    document.body.appendChild(bar);
    const accept = bar.querySelector('[data-accept]');
    const decline = bar.querySelector('[data-decline]');
    if (accept)  accept.addEventListener('click',  () => { localStorage.setItem(key, 'accepted'); apply('accepted'); bar.remove(); });
    if (decline) decline.addEventListener('click', () => { localStorage.setItem(key, 'declined'); apply('declined'); bar.remove(); });
  }

  apply(localStorage.getItem(key));
  document.addEventListener('DOMContentLoaded', () => {
    showChoices(false);
    document.querySelectorAll('[data-privacy-choices]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        showChoices(true);
      });
    });
  });
})();
